/**
 * One turn of the loading screen's shared timeline, in milliseconds.
 *
 * The scan sweep, the two glows behind it and the twinkling sparkle are all phases of a single
 * 2.75s loop in the design, which is why they read as one motion rather than three that happen
 * to be running. Keeping the number here rather than in each component is what holds them in
 * step: change it in one place and they stay a single timeline.
 */
export const LOADING_LOOP_MS = 2750;

/** Applied to every looping animation on this screen, so a member who asked for stillness gets it. */
export const REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';
